import { motion } from "framer-motion";

import robot from "./assets/aii-bot.png";
import badgeAutomation from "./assets/badge-automation.png";
import badgeIntegration from "./assets/badge-integration.png";
import badgeReduction from "./assets/badge-reduction.png";
import badgeComplexity from "./assets/badge-complexity.png";
import badgeDecision from "./assets/badge-decision.png";
import badgeStreamline from "./assets/badge-streamlined.png";
import grid from "./assets/grid-pattern.jpg";

const HeroSection = () => {
  const floatY = { y: [0, -8, 0] };
  const floatTransition = {
    duration: 3.2,
    repeat: Infinity,
    ease: "easeInOut",
  };

  return (
    <section className="relative bg-black text-white overflow-hidden w-full h-[450px] md:h-[600px] lg:h-[746px] px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8 xl:pt-20 pb-0">
      <img
        src={grid}
        alt="Grid background pattern"
        className="absolute top-0 left-0 w-full h-full object-cover pointer-events-none z-0"
      />

      <div className="relative z-20 max-w-[637px] mx-auto text-center flex flex-col items-center gap-10">
        <h2 className="text-[32px] md:text-[48px] xl:text-[64px] font-regular leading-none">
          <span className="bg-gradient-to-r from-[#7B41E6] to-[#ED72EF] text-transparent bg-clip-text">
            AI Solutions
          </span>
          <br />
          for your business
        </h2>

        <p className="bg-gradient-to-r from-[#999999] to-[#FFFFFF] text-transparent bg-clip-text text-[16px] md:text-[18px] leading-tight">
          AI solutions improve app functionality and user experience by
          utilizing{" "}
          <br className="hidden sm:block" />
          machine learning models and algorithms.
        </p>
      </div>

      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 z-20">
        <img
          src={robot}
          alt="AI robot illustration"
          className="w-[260px] sm:w-[400px] md:w-[500px] lg:w-[577px] h-auto"
        />
      </div>

      <motion.img
        src={badgeReduction}
        alt="Reduce labor cost"
        className="absolute w-[90px] sm:w-[120px] md:w-[180px] lg:w-[220px] top-[45%] left-[27%] z-30"
        animate={floatY}
        transition={{ ...floatTransition, duration: 3.1 }}
      />
      <motion.img
        src={badgeComplexity}
        alt="Minimized complexity"
        className="absolute w-[90px] sm:w-[120px] md:w-[180px] lg:w-[220px] top-[45%] right-[27%] z-30"
        animate={floatY}
        transition={{ ...floatTransition, duration: 3.2 }}
      />
      <motion.img
        src={badgeIntegration}
        alt="System integration"
        className="absolute w-[100px] sm:w-[180px] md:w-[230px] lg:w-[280px] top-[57%] left-[16%] z-30"
        animate={floatY}
        transition={{ ...floatTransition, duration: 2.8 }}
      />
      <motion.img
        src={badgeAutomation}
        alt="Process automation"
        className="absolute w-[110px] sm:w-[160px] md:w-[230px] lg:w-[350px] top-[70%] left-[4%] z-30"
        animate={floatY}
        transition={{ ...floatTransition, duration: 3.3 }}
      />
      <motion.img
        src={badgeDecision}
        alt="Better decision making"
        className="absolute w-[100px] sm:w-[140px] md:w-[200px] lg:w-[240px] top-[59%] right-[18%] z-30"
        animate={floatY}
        transition={{ ...floatTransition, duration: 3.1 }}
      />
      <motion.img
        src={badgeStreamline}
        alt="Streamlined operations"
        className="absolute w-[110px] sm:w-[160px] md:w-[230px] lg:w-[350px] top-[72%] right-[4%] z-30"
        animate={floatY}
        transition={{ ...floatTransition, duration: 3.4 }}
      />
    </section>
  );
};


export default HeroSection;
